// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"522":"1396d660","827":"addc88dd"}[chunkId] + ".chunk.js";
};